import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import { env } from "@/config/env";

import { appNotificationsKeys } from "./queryKeys";

const RECONNECT_DELAY_MS = 3000;

const configuredOrigin = new URL(env.VITE_BASE_API_URL).origin;

const WS_BASE_URL = (
  window.location.origin === configuredOrigin
    ? env.VITE_BASE_API_URL
    : window.location.origin
).replace(/^http/, "ws");

export function useNotificationsSocket(enabled: boolean): void {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!enabled) return;

    let socket: undefined | WebSocket;
    let reconnectTimer: ReturnType<typeof setTimeout> | undefined;
    let closedByEffectCleanup = false;

    const connect = () => {
      socket = new WebSocket(`${WS_BASE_URL}/api/v1/notifications/ws`);

      socket.addEventListener("message", (event) => {
        const data = JSON.parse(event.data);

        if (data.type === "notification:new") {
          queryClient.invalidateQueries({
            queryKey: appNotificationsKeys.all,
          });
        }
      });

      socket.addEventListener("close", () => {
        if (closedByEffectCleanup) return;
        reconnectTimer = setTimeout(connect, RECONNECT_DELAY_MS);
      });
    };

    connect();

    return () => {
      closedByEffectCleanup = true;
      clearTimeout(reconnectTimer);
      socket?.close();
    };
  }, [enabled, queryClient]);
}
